<template>
  <v-layout row wrap>
    <v-flex>
      <v-widget class="px-0" :title="titulo" content-bg="white">
        <div slot="widget-content">
          <e-chart
            :path-option="[
              ['dataset.source', res],
              ['legend.bottom', '0'],
              [
                'color',
                [color.lightBlue.base, color.orange.base, color.grey.base],
              ],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie'],
              ['series[0].avoidLabelOverlap', true],
              ['series[0].radius', ['50%', '70%']],
            ]"
            height="400px"
            width="100%"
          >
          </e-chart>
        </div>
      </v-widget>
      <v-container grid-list-md text-xs-center>
        <u
          class="blue--text"
          @click="ViewByRegion(titleIn, nivelFiltro, fechaProgreso)"
          >Ver por region</u
        >
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import API from "@/api";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "boton-proceso",

  props: {
    res: [],
    titulo: [],
    titleIn: [],
    nivelFiltro: "",
    fechaProgreso: "",
  },

  components: {
    VWidget,
    EChart,
    CircleStatistic,
  },

  mixins: [misMixins],
  data: () => ({
    color: Material,
  }),

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
  },

  methods: {
    ViewByRegion(tip, niv, fec) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "EvolucionRegion",
          params: {
            tipeView: "consulta",
            tipoPrueba: tip,
            nivelFiltro: niv,
            fechaFiltro: fec,
          },
        });
      }, 1000);
    },
  },
};
</script>
